import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoogleSheets = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 37,
	height: 37,
	viewBox: "0 0 37 37",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1440_3932)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M2 6.16667C2 5.0616 2.43899 4.00179 3.22039 3.22039C4.00179 2.43899 5.0616 2 6.16667 2H31.1667C32.2717 2 33.3315 2.43899 34.1129 3.22039C34.8943 4.00179 35.3333 5.0616 35.3333 6.16667V31.1667C35.3333 32.2717 34.8943 33.3315 34.1129 34.1129C33.3315 34.8943 32.2717 35.3333 31.1667 35.3333H6.16667C5.0616 35.3333 4.00179 34.8943 3.22039 34.1129C2.43899 33.3315 2 32.2717 2 31.1667V6.16667Z",
				stroke: "#0F9D58",
				strokeWidth: 3,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.66675 14.6667L29.6667 14.6667",
				stroke: "#0F9D58",
				strokeWidth: 3,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.6667 7.66675L14.6667 29.6667",
				stroke: "#0F9D58",
				strokeWidth: 3,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1440_3932",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 37,
			height: 37,
			fill: "white"
		})
	}) })]
});
export default SvgGoogleSheets;
